export default "__VITE_ASSET__Cn5nW50X__"